import styles from './Icon.module.scss';

const SpeculativeIcon = ({ showtitle }: { showtitle?: boolean }): React.ReactElement => {
  return (
    <div className={styles.scorevalues}>
      <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect width="20" height="20" rx="2" fill="#F7B0B0" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M6 11.5L10 14.5L14 11.5L14 9.5L10 12.5L6 9.5L6 11.5ZM6 7.5L10 10.5L14 7.5L14 5.5L10 8.5L6 5.5L6 7.5Z"
          fill="#174174"
        />
      </svg>
      {showtitle ? <p>Speculative</p> : ''}
    </div>
  );
};

export default SpeculativeIcon;
